<script lang="ts">
	import { setContext } from "svelte";
	import type { ContentBlock as ContentBlockData, SavedContentBlock } from "@core/schema/ContentBlock.js";
	import type { Product } from "@core/schema/Product.js";
	import ContentBlock from "./ContentBlock.svelte";
	import InquiryModalForm from "./InquiryModalForm.svelte";

	const componentId = $props.id();
	const {
		blocks,
		productId,
		lightboxIdPerBlock = false,
		lightboxId = lightboxIdPerBlock ? undefined : componentId,
		align = "center",
	}: {
		blocks: (SavedContentBlock | ContentBlockData)[];
		lightboxIdPerBlock?: boolean;
		productId?: Product["id"];
		lightboxId?: string;
		align: "center" | "left";
	} = $props();

	let showInquiryForm = $state(false);

	setContext("openInquiryForm", (): void => {
		showInquiryForm = true;
	});

	const mediaAlign =
		align === "center" ? "[&_.ckeditor-content_figure.media]:mx-auto" : "[&_.ckeditor-content_figure.media]:mx-0";
</script>

<InquiryModalForm {productId} bind:showInquiryForm />

<div
	class={[
		"flex flex-col gap-8 md:gap-12 lg:gap-16 full-width grid-container",
		"[&_.ckeditor-content]:w-full [&_.ckeditor-content]:text-left",

		align === "center" &&
			"[&_.ckeditor-content>*:not(figure.media)]:max-w-screen-md [&_.ckeditor-content>*:not(figure.media)]:mx-auto",

		align === "left" &&
			"[&_.ckeditor-content>*:not(figure.media)]:max-w-screen-md [&_.ckeditor-content>*:not(figure.media)]:mx-0",

		"[&_.ckeditor-content_figure.media]:w-full [&_.ckeditor-content_figure.media]:max-w-screen-md [&_.ckeditor-content_figure.media]:my-6 [&_.ckeditor-content_figure.media]:max-lg:my-12",
		mediaAlign,
	]}
>
	{#each blocks as block (block.id)}
		<ContentBlock {block} {lightboxId} {align} />
	{/each}
</div>
